module.exports = __webpack_public_path__ + "static/media/5. Wahyu.103d5c01.png";